import React, { useEffect, useState } from "react";
import SpendChartNIASimulator from "./spendChartNIASimulator";
import RebateChartNIASimulator from "./rebateChartNIASimulator";

const RebateTrend = (props: any) => {
	const chartData = props.data.trendViewByQuarters;
	const spendText = props.spendText;

	const [spendChartData, setSpendChartData] = useState<any>(null);
	const [niaChartData, setNiaChartData] = useState<any>(null);

	useEffect(() => {
		console.log(chartData,"cahrtdata")
		setSpendChartData(
			Object.values(chartData).map((obj: any, index: number) => {
				obj.quarter =
					"Q" + (index + 1) + "-" + new Date().getFullYear();
				obj.targetGrowthSales = 0;
				obj.targetGrowthSalesLabel =
					obj.actualSales +
					obj.forecasetdSales +
					obj.additionalPurchases;

				// obj.spendShift = obj.actual ? 0 :  obj.spendNeededForNextTier - obj.forecastedSpend
				// obj.lastYearSpend=chartData?.lastYearChartData['Q' + (index + 1)]
				// obj.targetGrowthSpend = obj.actual ? 0 : obj.spendNeededForNextTier + obj.forecastedSpend

				return obj;
			})
		);

		setNiaChartData(
			Object.values(chartData).map((obj: any, index: number) => {
				obj.quarter =
					"Q" + (index + 1) + "-" + new Date().getFullYear();
				if (index === 3) {
					obj.forecastedGrowth = props.data.kpi.forecastedGrowth;
				}
				obj.totalRebate = 0;
				obj.totalRebateLabel =
					obj.actualBase + obj.forecasetdBase + obj.additionalBase;
				obj.totalGrowthRebate = 0;
				obj.totalGrowthRebateLabel =
					props.data.kpi.forecastedGrowth + obj.additionalGrowth;
				return obj;
			})
		);
	}, [props.data.trendViewByQuarters]);

	console.log(spendChartData,niaChartData,"rebatetrend")

	return (
		<>
			<div className="grid grid-cols-2 h-[45vh] mt-[2vh] gap-x-[2vh]">
				<div className="flex justify-center graphBox">
					<SpendChartNIASimulator
						chartData={spendChartData}
						spendText={spendText}
					/>
				</div>
				<div className="flex justify-center graphBox">
					<RebateChartNIASimulator chartData={niaChartData} />
				</div>
			</div>

			{/* <div className="grid grid-cols-4 gap-6 text-white text-0.95vw">
        <span className="flex items-center text-[80%]">
          <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
          2024 Actuals
        </span>
        <span className="flex items-center text-[80%]">
          <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
          2024 Target Growth Spend
        </span>
        <span className="flex items-center text-[80%]">
          <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
          Forecasted Base NIA $
        </span>
        <span className="flex items-center text-[80%]">
          <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
          Additional Base NIA $
        </span>
        <span className="flex items-center text-[80%]">
          <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
          2024 Current Growth Spend
        </span>

        <span className="flex items-center text-[80%]">
          <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
          Spend Shift/Increase
        </span>
        <span className="flex items-center text-[80%]">
          <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
          Forecasted Growth NIA$
        </span>
        <span className="flex items-center text-[80%]">
          <span className="h-[15px] w-[15px] border-white bg-[#9ACD32] mx-4"></span>
          Additional Growth NIA $
        </span>
      </div> */}
		</>
	);
};

export default RebateTrend;
